import { ESdChangeReason } from "@kuika/kuika-cl-model";
import { IWithSDProps, withSD } from "../../../../../shared/hoc/screen-design-consumer";
import { IWithContextProp, withContext } from "../../../../../shared/hoc/with-context";
import { PureSdComponent } from "../../../../../shared/pure-sd";
import { KModal } from "../../../../ui-kit/k-modal/k-modal";
import KuikaButton from "../../../../ui-kit/kuika-button/kuika-button";
import "./data-key-editor.scss";
import { DataKeyTextFieldList } from "./data-key-text-field-list";

export interface IDataKeyTextEditorState {
  showModal: boolean;
}

export interface IDataKeyTextEditorProps {
  value: string;
  onChange?: (value: string) => void;
}

class DataKeyTextEditor extends PureSdComponent<
  IDataKeyTextEditorProps & IWithSDProps & IWithContextProp,
  IDataKeyTextEditorState
> {
  constructor(props: IDataKeyTextEditorProps & IWithSDProps & IWithContextProp) {
    super(props);
    this.state = { showModal: false };
  }

  handleClickData = () => {
    this.setState({ showModal: true });
  };

  handleCloseModal = () => {
    this.setState({ showModal: false });
  };

  handleChangedDataKeyList = (value: string) => {
    this.setState({ showModal: false }, () => {
      if (this.props.onChange) {
        this.props.onChange(value);
      }
    });
  };

  render() {
    return (
      <>
        <KuikaButton
          className="data-key-editor__trigger-button"
          onClick={this.handleClickData}
          type="secondary"
          aria-label="Open fixed data editor"
        >
          Fixed Data
        </KuikaButton>
        <KModal
          showModal={this.state.showModal}
          closeModal={this.handleCloseModal}
          header="Add Fixed Data"
          footer={null}
          width={800}
          className="data-key-editor__modal"
        >
          <DataKeyTextFieldList
            value={this.props.value}
            onChange={this.handleChangedDataKeyList}
            handleClickOnCancel={this.handleCloseModal}
          />
        </KModal>
      </>
    );
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    if (
      changeReason === ESdChangeReason.ChangeSelectedDiByCanvasFrame ||
      changeReason === ESdChangeReason.ChangeSelectedDiByTools ||
      changeReason === ESdChangeReason.DragDropDi ||
      changeReason === ESdChangeReason.DragDropBlock
    ) {
      return true;
    }
    return false;
  };
}

const dataKeyTextEditor = withContext<IDataKeyTextEditorProps>(withSD<IDataKeyTextEditorProps>(DataKeyTextEditor));
export { dataKeyTextEditor as DataKeyTextEditor };
